import { render, staticRenderFns } from "./minio-uplode.vue?vue&type=template&id=0cb0478c&scoped=true&"
import script from "./minio-uplode.vue?vue&type=script&lang=js&"
export * from "./minio-uplode.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0cb0478c",
  null
  
)

export default component.exports